/**
 * Browse / active / history investments + invest modal + stop-loss assign CTA.
 * Merged into locales that otherwise fall back to English for these keys.
 */
export const panelInvestmentsByLang = {
  es: {
    'user.investments.loadingActive': 'Cargando inversiones activas…',
    'user.investments.loadFailed': 'No se pudieron cargar las inversiones activas',
    'user.investments.emptyTitle': 'Sin inversiones activas',
    'user.investments.emptyDesc': 'Explora planes e invierte para empezar',
    'user.investments.browsePlans': 'Explorar planes',
    'user.investments.tab.browse': 'Explorar planes',
    'user.investments.tab.active': 'Inversiones activas',
    'user.investments.tab.history': 'Historial',
    'user.investments.plan.compound': 'Interés compuesto',
    'user.investments.plan.simple': 'Interés simple',
    'user.investments.card.minPrincipal': 'Principal mín.',
    'user.investments.card.maxPrincipal': 'Principal máx.',
    'user.investments.card.interestRate': 'Tipo de interés',
    'user.investments.card.dailyProfit': 'Beneficio diario',
    'user.investments.card.earningDays': 'Días hábiles',
    'user.investments.card.earningDaysValue': '{{count}} días hábiles',
    'user.investments.card.duration': 'Duración',
    'user.investments.card.durationMonths': '{{n}} meses',
    'user.investments.duration.oneDay': '1 día',
    'user.investments.duration.daysOnly': '{{days}} días',
    'user.investments.duration.oneMonth': '1 mes',
    'user.investments.duration.monthsOnly': '{{months}} meses',
    'user.investments.duration.daysAndMonths': '{{months}} meses {{days}} días',
    'user.investments.card.interestType': 'Tipo de interés',
    'user.investments.card.expectedProfit': 'Beneficio esperado',
    'user.investments.card.totalReturn': 'Rentabilidad total',
    'user.investments.card.comingSoonLine': 'Próximamente',
    'user.investments.card.launchingSoon': 'Muy pronto — permanece atento',
    'user.investments.card.comingSoonBadge': 'Próximamente',
    'user.investments.card.notAvailable': 'No disponible',
    'user.investments.card.investNow': 'Invertir ahora',
    'user.investments.card.investLimit': 'Límite de inversión',
    'user.investments.card.investLimitLine': '{{count}}× en {{days}} días',
    'user.investments.card.investLimitReached':
      'Has alcanzado el límite de inversión de este plan en el período actual.',
    'user.investments.card.limitReached': 'Límite alcanzado',
    'user.investments.history.title': 'Historial de inversiones',
    'user.investments.history.loading': 'Cargando historial…',
    'user.investments.history.empty': 'Aún no hay historial de inversiones.',
    'user.investments.history.col.plan': 'Plan',
    'user.investments.history.col.amount': 'Importe invertido',
    'user.investments.history.col.rate': 'Tipo de interés',
    'user.investments.history.col.duration': 'Duración',
    'user.investments.history.col.returns': 'Rentabilidad obtenida',
    'user.investments.history.col.endDate': 'Fecha fin',
    'user.investments.history.col.status': 'Estado',
    'user.investments.history.months': '{{n}} meses',
    'user.investments.history.rateMo': '{{pct}}%/mes',
    'user.investments.history.rateTerm': '{{pct}}%',
    'user.investments.history.rateDay': '{{pct}}%/day',
    'user.investments.history.st.active': 'Activo',
    'user.investments.history.st.cancelled': 'Cancelado',
    'user.investments.history.st.completed': 'Completado',
    'user.investments.history.st.pending': 'Pendiente',
    'user.investments.modal.amountLabel': 'Importe (USD)',
    'user.investments.modal.placeholderAmount': 'Introduce el importe',
    'user.investments.modal.minMax': 'Mín: {{min}} · Máx: {{max}}',
    'user.investments.modal.available': 'Saldo disponible: {{amount}}',
    'user.investments.modal.availableLoading': 'Saldo disponible: cargando…',
    'user.investments.modal.errMin': 'La inversión mínima es {{min}}',
    'user.investments.modal.errMax': 'La inversión máxima es {{max}}',
    'user.investments.modal.errInsufficient':
      'Saldo insuficiente. Necesitas {{amount}} pero solo tienes {{available}}.',
    'user.investments.modal.toastInsufficient': 'Saldo insuficiente. Deposita primero.',
    'user.investments.modal.projectedTitle': 'Rentabilidad prevista',
    'user.investments.modal.periodInterestTerm': 'Interés del plan',
    'user.investments.modal.periodInterestDay': 'Interés diario',
    'user.investments.modal.periodInterestYear': 'Equivalente mensual',
    'user.investments.modal.monthlyInterest': 'Interés mensual',
    'user.investments.modal.totalInterest': 'Interés total',
    'user.investments.modal.totalWithdrawal': 'Retiro total',
    'user.investments.modal.periodHoursOnly': '{{hours}} horas',
    'user.investments.modal.periodDaysOnly': '{{days}} días',
    'user.investments.modal.periodDaysHours': '{{days}} días {{hours}} horas',
    'user.investments.modal.hintPlanChange':
      'Cambio de plan permitido en las {{period}} tras la selección',
    'user.investments.modal.hintCancellation':
      'La inversión puede cancelarse en los primeros {{period}}',
    'user.investments.modal.hintWeekdayOnly':
      'El interés se acredita al saldo disponible solo entre semana',
    'user.investments.modal.submit': 'Confirmar inversión',
    'user.investments.modal.submitting': 'Procesando…',
    'user.investments.modal.toastInvalidAmount': 'Introduce un importe válido.',
    'user.investments.modal.toastSubscribeFail': 'No se pudo suscribir',
    'user.investments.modal.toastSubscribeOk': 'Inversión suscrita correctamente',
    'user.investments.earlyWithdraw.title': 'Aviso de retiro anticipado',
    'user.investments.earlyWithdraw.investmentAmount': 'Importe invertido:',
    'user.investments.earlyWithdraw.platformFee': 'Comisión de plataforma ({{pct}}%):',
    'user.investments.earlyWithdraw.interestForfeited': 'Intereses perdidos:',
    'user.investments.earlyWithdraw.interestIncluded': 'Incluido',
    'user.investments.earlyWithdraw.youReceive': 'Recibirás:',
    'user.investments.earlyWithdraw.processing': 'Procesando…',
    'user.investments.earlyWithdraw.confirm': 'Confirmar',
    'user.investments.active.planFallback': 'Plan',
    'user.investments.active.badgeActive': 'Activo',
    'user.investments.active.labelAmount': 'Importe',
    'user.investments.active.labelCurrent': 'Valor actual',
    'user.investments.active.labelRate': 'Tipo',
    'user.investments.active.ratePerMonth': '{{pct}}% / mes',
    'user.investments.active.labelPl': 'B/P',
    'user.investments.active.labelInterestEst': 'Intereses (est.)',
    'user.investments.active.labelStart': 'Fecha de inicio',
    'user.investments.active.labelMaturity': 'Fecha de vencimiento',
    'user.investments.active.nextWithdrawal': 'Próximo retiro en',
    'user.investments.active.progress': 'Progreso',
    'user.investments.active.progressPct': '{{pct}}% completado',
    'user.investments.active.earlyWithdrawCta': 'Retiro anticipado',
    'user.stopLoss.slots.assignCta': 'Asignar a plan de inversión',
  },

  de: {
    'user.investments.loadingActive': 'Aktive Investitionen werden geladen…',
    'user.investments.loadFailed': 'Aktive Investitionen konnten nicht geladen werden',
    'user.investments.emptyTitle': 'Keine aktiven Investitionen',
    'user.investments.emptyDesc': 'Durchsuchen Sie Pläne und investieren Sie, um zu starten',
    'user.investments.browsePlans': 'Pläne durchsuchen',
    'user.investments.tab.browse': 'Pläne durchsuchen',
    'user.investments.tab.active': 'Aktive Investitionen',
    'user.investments.tab.history': 'Verlauf',
    'user.investments.plan.compound': 'Zinseszins',
    'user.investments.plan.simple': 'Einfacher Zins',
    'user.investments.card.minPrincipal': 'Mindestkapital',
    'user.investments.card.maxPrincipal': 'Höchstkapital',
    'user.investments.card.interestRate': 'Zinssatz',
    'user.investments.card.dailyProfit': 'Täglicher Gewinn',
    'user.investments.card.earningDays': 'Werktage',
    'user.investments.card.earningDaysValue': '{{count}} Werktage',
    'user.investments.card.duration': 'Laufzeit',
    'user.investments.card.durationMonths': '{{n}} Monate',
    'user.investments.card.interestType': 'Zinsart',
    'user.investments.card.expectedProfit': 'Erwarteter Gewinn',
    'user.investments.card.totalReturn': 'Gesamtrendite',
    'user.investments.card.comingSoonLine': 'Demnächst',
    'user.investments.card.launchingSoon': 'Start demnächst — bleiben Sie dran',
    'user.investments.card.comingSoonBadge': 'Demnächst',
    'user.investments.card.notAvailable': 'Nicht verfügbar',
    'user.investments.card.investNow': 'Jetzt investieren',
    'user.investments.card.investLimit': 'Investitionslimit',
    'user.investments.card.investLimitLine': '{{count}}× in {{days}} Tagen',
    'user.investments.card.investLimitReached':
      'Du hast das Investitionslimit für diesen Plan im aktuellen Zeitraum erreicht.',
    'user.investments.card.limitReached': 'Limit erreicht',
    'user.investments.history.title': 'Investitionsverlauf',
    'user.investments.history.loading': 'Verlauf wird geladen…',
    'user.investments.history.empty': 'Noch kein Investitionsverlauf.',
    'user.investments.history.col.plan': 'Plan',
    'user.investments.history.col.amount': 'Investierter Betrag',
    'user.investments.history.col.rate': 'Zinssatz',
    'user.investments.history.col.duration': 'Laufzeit',
    'user.investments.history.col.returns': 'Erzielte Rendite',
    'user.investments.history.col.endDate': 'Enddatum',
    'user.investments.history.col.status': 'Status',
    'user.investments.history.months': '{{n}} Monate',
    'user.investments.history.rateMo': '{{pct}}%/Monat',
    'user.investments.history.rateTerm': '{{pct}}%',
    'user.investments.history.rateDay': '{{pct}}%/day',
    'user.investments.history.st.active': 'Aktiv',
    'user.investments.history.st.cancelled': 'Storniert',
    'user.investments.history.st.completed': 'Abgeschlossen',
    'user.investments.history.st.pending': 'Ausstehend',
    'user.investments.modal.amountLabel': 'Betrag (USD)',
    'user.investments.modal.placeholderAmount': 'Betrag eingeben',
    'user.investments.modal.minMax': 'Min: {{min}} · Max: {{max}}',
    'user.investments.modal.available': 'Verfügbares Guthaben: {{amount}}',
    'user.investments.modal.availableLoading': 'Verfügbares Guthaben: wird geladen…',
    'user.investments.modal.errMin': 'Mindestinvestition ist {{min}}',
    'user.investments.modal.errMax': 'Höchstinvestition ist {{max}}',
    'user.investments.modal.errInsufficient':
      'Unzureichendes Guthaben. Sie benötigen {{amount}}, verfügbar sind nur {{available}}.',
    'user.investments.modal.toastInsufficient': 'Unzureichendes Guthaben. Bitte zuerst einzahlen.',
    'user.investments.modal.projectedTitle': 'Voraussichtliche Rendite',
    'user.investments.modal.periodInterestTerm': 'Planzins',
    'user.investments.modal.periodInterestDay': 'Tageszins',
    'user.investments.modal.periodInterestYear': 'Monatliches Äquivalent',
    'user.investments.modal.monthlyInterest': 'Monatszins',
    'user.investments.modal.totalInterest': 'Gesamtzins',
    'user.investments.modal.totalWithdrawal': 'Gesamtauszahlung',
    'user.investments.modal.periodHoursOnly': '{{hours}} Stunden',
    'user.investments.modal.periodDaysOnly': '{{days}} Tage',
    'user.investments.modal.periodDaysHours': '{{days}} Tage {{hours}} Stunden',
    'user.investments.modal.hintPlanChange':
      'Planwechsel innerhalb von {{period}} nach Auswahl möglich',
    'user.investments.modal.hintCancellation':
      'Investition kann in den ersten {{period}} gekündigt werden',
    'user.investments.modal.hintWeekdayOnly':
      'Zinsen werden nur an Werktagen dem verfügbaren Guthaben gutgeschrieben',
    'user.investments.modal.submit': 'Investition bestätigen',
    'user.investments.modal.submitting': 'Wird verarbeitet…',
    'user.investments.modal.toastInvalidAmount': 'Bitte einen gültigen Betrag eingeben.',
    'user.investments.modal.toastSubscribeFail': 'Zeichnung fehlgeschlagen',
    'user.investments.modal.toastSubscribeOk': 'Investition erfolgreich gezeichnet',
    'user.investments.earlyWithdraw.title': 'Hinweis vorzeitige Auszahlung',
    'user.investments.earlyWithdraw.investmentAmount': 'Investitionsbetrag:',
    'user.investments.earlyWithdraw.platformFee': 'Plattformgebühr ({{pct}}%):',
    'user.investments.earlyWithdraw.interestForfeited': 'Verfallene Zinsen:',
    'user.investments.earlyWithdraw.interestIncluded': 'Enthalten',
    'user.investments.earlyWithdraw.youReceive': 'Sie erhalten:',
    'user.investments.earlyWithdraw.processing': 'Wird verarbeitet…',
    'user.investments.earlyWithdraw.confirm': 'Bestätigen',
    'user.investments.active.planFallback': 'Plan',
    'user.investments.active.badgeActive': 'Aktiv',
    'user.investments.active.labelAmount': 'Betrag',
    'user.investments.active.labelCurrent': 'Aktueller Wert',
    'user.investments.active.labelRate': 'Satz',
    'user.investments.active.ratePerMonth': '{{pct}}% / Monat',
    'user.investments.active.labelPl': 'G/V',
    'user.investments.active.labelInterestEst': 'Zins (geschätzt)',
    'user.investments.active.labelStart': 'Startdatum',
    'user.investments.active.labelMaturity': 'Fälligkeitsdatum',
    'user.investments.active.nextWithdrawal': 'Nächste Auszahlung in',
    'user.investments.active.progress': 'Fortschritt',
    'user.investments.active.progressPct': '{{pct}}% abgeschlossen',
    'user.investments.active.earlyWithdrawCta': 'Vorzeitige Auszahlung',
    'user.stopLoss.slots.assignCta': 'Investitionsplan zuweisen',
  },
};

/** Same keys as `panelInvestmentsByLang.es` — merged after `en` for listed locales. */
export const panelInvestmentsOverrides = {
  fr: {
    'user.investments.loadingActive': 'Chargement des investissements actifs…',
    'user.investments.loadFailed': 'Impossible de charger les investissements actifs',
    'user.investments.emptyTitle': 'Aucun investissement actif',
    'user.investments.emptyDesc': 'Parcourez les plans et investissez pour commencer',
    'user.investments.browsePlans': 'Parcourir les plans',
    'user.investments.tab.browse': 'Parcourir les plans',
    'user.investments.tab.active': 'Investissements actifs',
    'user.investments.tab.history': 'Historique',
    'user.investments.plan.compound': 'Intérêts composés',
    'user.investments.plan.simple': 'Intérêts simples',
    'user.investments.card.minPrincipal': 'Principal min.',
    'user.investments.card.maxPrincipal': 'Principal max.',
    'user.investments.card.interestRate': 'Taux d’intérêt',
    'user.investments.card.dailyProfit': 'Profit journalier',
    'user.investments.card.earningDays': 'Jours ouvrables',
    'user.investments.card.earningDaysValue': '{{count}} jours ouvrables',
    'user.investments.card.duration': 'Durée',
    'user.investments.card.durationMonths': '{{n}} mois',
    'user.investments.card.interestType': 'Type d’intérêt',
    'user.investments.card.expectedProfit': 'Profit attendu',
    'user.investments.card.totalReturn': 'Rendement total',
    'user.investments.card.comingSoonLine': 'Bientôt',
    'user.investments.card.launchingSoon': 'Lancement prochain — restez informé',
    'user.investments.card.comingSoonBadge': 'Bientôt',
    'user.investments.card.notAvailable': 'Indisponible',
    'user.investments.card.investNow': 'Investir maintenant',
    'user.investments.card.investLimit': "Limite d'investissement",
    'user.investments.card.investLimitLine': '{{count}}× en {{days}} jours',
    'user.investments.card.investLimitReached':
      "Vous avez atteint la limite d'investissement pour ce plan sur la période en cours.",
    'user.investments.card.limitReached': 'Limite atteinte',
    'user.investments.history.title': 'Historique des investissements',
    'user.investments.history.loading': 'Chargement de l’historique…',
    'user.investments.history.empty': 'Pas encore d’historique d’investissement.',
    'user.investments.history.col.plan': 'Plan',
    'user.investments.history.col.amount': 'Montant investi',
    'user.investments.history.col.rate': 'Taux d’intérêt',
    'user.investments.history.col.duration': 'Durée',
    'user.investments.history.col.returns': 'Gains réalisés',
    'user.investments.history.col.endDate': 'Date de fin',
    'user.investments.history.col.status': 'Statut',
    'user.investments.history.months': '{{n}} mois',
    'user.investments.history.rateMo': '{{pct}}%/mois',
    'user.investments.history.rateTerm': '{{pct}}%',
    'user.investments.history.rateDay': '{{pct}}%/day',
    'user.investments.history.st.active': 'Actif',
    'user.investments.history.st.cancelled': 'Annulé',
    'user.investments.history.st.completed': 'Terminé',
    'user.investments.history.st.pending': 'En attente',
    'user.investments.modal.amountLabel': 'Montant (USD)',
    'user.investments.modal.placeholderAmount': 'Saisir le montant',
    'user.investments.modal.minMax': 'Min : {{min}} · Max : {{max}}',
    'user.investments.modal.available': 'Solde disponible : {{amount}}',
    'user.investments.modal.availableLoading': 'Solde disponible : chargement…',
    'user.investments.modal.errMin': 'L’investissement minimum est {{min}}',
    'user.investments.modal.errMax': 'L’investissement maximum est {{max}}',
    'user.investments.modal.errInsufficient':
      'Solde insuffisant. Il vous faut {{amount}}, disponible : {{available}}.',
    'user.investments.modal.toastInsufficient': 'Solde insuffisant. Veuillez déposer des fonds.',
    'user.investments.modal.projectedTitle': 'Rendements prévisionnels',
    'user.investments.modal.periodInterestTerm': 'Intérêt du plan',
    'user.investments.modal.periodInterestDay': 'Intérêt journalier',
    'user.investments.modal.periodInterestYear': 'Équivalent mensuel',
    'user.investments.modal.monthlyInterest': 'Intérêts mensuels',
    'user.investments.modal.totalInterest': 'Intérêts totaux',
    'user.investments.modal.totalWithdrawal': 'Retrait total',
    'user.investments.modal.periodHoursOnly': '{{hours}} heures',
    'user.investments.modal.periodDaysOnly': '{{days}} jours',
    'user.investments.modal.periodDaysHours': '{{days}} jours {{hours}} heures',
    'user.investments.modal.hintPlanChange':
      'Changement de plan autorisé dans les {{period}} suivant le choix',
    'user.investments.modal.hintCancellation':
      'L’investissement peut être annulé dans les {{period}}',
    'user.investments.modal.hintWeekdayOnly':
      'Les intérêts sont crédités sur le solde disponible en semaine uniquement',
    'user.investments.modal.submit': 'Confirmer l’investissement',
    'user.investments.modal.submitting': 'Traitement…',
    'user.investments.modal.toastInvalidAmount': 'Veuillez saisir un montant valide.',
    'user.investments.modal.toastSubscribeFail': 'Échec de la souscription',
    'user.investments.modal.toastSubscribeOk': 'Investissement souscrit avec succès',
    'user.investments.earlyWithdraw.title': 'Avertissement retrait anticipé',
    'user.investments.earlyWithdraw.investmentAmount': 'Montant investi :',
    'user.investments.earlyWithdraw.platformFee': 'Frais de plateforme ({{pct}}%) :',
    'user.investments.earlyWithdraw.interestForfeited': 'Intérêts perdus :',
    'user.investments.earlyWithdraw.interestIncluded': 'Inclus',
    'user.investments.earlyWithdraw.youReceive': 'Vous recevrez :',
    'user.investments.earlyWithdraw.processing': 'Traitement…',
    'user.investments.earlyWithdraw.confirm': 'Confirmer',
    'user.investments.active.planFallback': 'Plan',
    'user.investments.active.badgeActive': 'Actif',
    'user.investments.active.labelAmount': 'Montant',
    'user.investments.active.labelCurrent': 'Valeur actuelle',
    'user.investments.active.labelRate': 'Taux',
    'user.investments.active.ratePerMonth': '{{pct}}% / mois',
    'user.investments.active.labelPl': 'P/P',
    'user.investments.active.labelInterestEst': 'Intérêts (est.)',
    'user.investments.active.labelStart': 'Date de début',
    'user.investments.active.labelMaturity': 'Date d’échéance',
    'user.investments.active.nextWithdrawal': 'Prochain retrait dans',
    'user.investments.active.progress': 'Progression',
    'user.investments.active.progressPct': '{{pct}}% terminé',
    'user.investments.active.earlyWithdrawCta': 'Retrait anticipé',
    'user.stopLoss.slots.assignCta': 'Assigner au plan d’investissement',
    'user.withdraw.form.amount': 'Montant (USD)',
    'user.withdraw.form.available': 'Solde disponible :',
    'user.withdraw.form.placeholderAmount': '0,00',
    'user.withdraw.form.feeTitle': 'Frais de retrait : {{pct}}%',
    'user.withdraw.form.feeBody':
      'Des frais de {{pct}}% sont déduits du montant du retrait. L\'annulation anticipée d\'un plan utilise des frais distincts.',
    'user.withdraw.form.noFeeTitle': 'Sans frais de plateforme',
    'user.withdraw.form.noFeeBody':
      'Les retraits vers le portefeuille sont sans frais de plateforme. L\'annulation anticipée d\'un plan utilise des frais distincts.',
    'user.withdraw.form.walletPlaceholder': 'Saisissez l’adresse USDT du portefeuille',
    'user.withdraw.form.loadingBalance': 'Chargement…',
  },

  ar: {
    'user.investments.loadingActive': 'جاري تحميل الاستثمارات النشطة…',
    'user.investments.loadFailed': 'تعذر تحميل الاستثمارات النشطة',
    'user.investments.emptyTitle': 'لا توجد استثمارات نشطة',
    'user.investments.emptyDesc': 'تصفح الخطط واستثمر للبدء',
    'user.investments.browsePlans': 'استعراض الخطط',
    'user.investments.tab.browse': 'استعراض الخطط',
    'user.investments.tab.active': 'الاستثمارات النشطة',
    'user.investments.tab.history': 'السجل',
    'user.investments.plan.compound': 'فائدة مركبة',
    'user.investments.plan.simple': 'فائدة بسيطة',
    'user.investments.card.minPrincipal': 'الحد الأدنى للرأسمال',
    'user.investments.card.maxPrincipal': 'الحد الأقصى للرأسمال',
    'user.investments.card.interestRate': 'معدل الفائدة',
    'user.investments.card.dailyProfit': 'الربح اليومي',
    'user.investments.card.earningDays': 'أيام العمل',
    'user.investments.card.earningDaysValue': '{{count}} يوم عمل',
    'user.investments.card.duration': 'المدة',
    'user.investments.card.durationMonths': '{{n}} أشهر',
    'user.investments.card.interestType': 'نوع الفائدة',
    'user.investments.card.expectedProfit': 'الربح المتوقع',
    'user.investments.card.totalReturn': 'العائد الإجمالي',
    'user.investments.card.comingSoonLine': 'قريباً',
    'user.investments.card.launchingSoon': 'إطلاق قريب — تابعنا',
    'user.investments.card.comingSoonBadge': 'قريباً',
    'user.investments.card.notAvailable': 'غير متاح',
    'user.investments.card.investNow': 'استثمر الآن',
    'user.investments.card.investLimit': 'حد الاستثمار',
    'user.investments.card.investLimitLine': '{{count}}× في {{days}} يومًا',
    'user.investments.card.investLimitReached':
      'لقد وصلت إلى حد الاستثمار لهذه الخطة في الفترة الحالية.',
    'user.investments.card.limitReached': 'تم بلوغ الحد',
    'user.investments.history.title': 'سجل الاستثمار',
    'user.investments.history.loading': 'جاري تحميل السجل…',
    'user.investments.history.empty': 'لا يوجد سجل استثمار بعد.',
    'user.investments.history.col.plan': 'الخطة',
    'user.investments.history.col.amount': 'المبلغ المستثمر',
    'user.investments.history.col.rate': 'معدل الفائدة',
    'user.investments.history.col.duration': 'المدة',
    'user.investments.history.col.returns': 'العوائد المحققة',
    'user.investments.history.col.endDate': 'تاريخ الانتهاء',
    'user.investments.history.col.status': 'الحالة',
    'user.investments.history.months': '{{n}} أشهر',
    'user.investments.history.rateMo': '{{pct}}%/شهر',
    'user.investments.history.rateTerm': '{{pct}}%',
    'user.investments.history.rateDay': '{{pct}}%/day',
    'user.investments.history.st.active': 'نشط',
    'user.investments.history.st.cancelled': 'ملغى',
    'user.investments.history.st.completed': 'مكتمل',
    'user.investments.history.st.pending': 'معلق',
    'user.investments.modal.amountLabel': 'المبلغ (USD)',
    'user.investments.modal.placeholderAmount': 'أدخل المبلغ',
    'user.investments.modal.minMax': 'الحد الأدنى: {{min}} · الأقصى: {{max}}',
    'user.investments.modal.available': 'الرصيد المتاح: {{amount}}',
    'user.investments.modal.availableLoading': 'الرصيد المتاح: جاري التحميل…',
    'user.investments.modal.errMin': 'الحد الأدنى للاستثمار {{min}}',
    'user.investments.modal.errMax': 'الحد الأقصى للاستثمار {{max}}',
    'user.investments.modal.errInsufficient':
      'رصيد غير كافٍ. تحتاج {{amount}} والمتاح {{available}}.',
    'user.investments.modal.toastInsufficient': 'رصيد غير كافٍ. يرجى الإيداع أولاً.',
    'user.investments.modal.projectedTitle': 'العوائد المتوقعة',
    'user.investments.modal.periodInterestTerm': 'فائدة الخطة',
    'user.investments.modal.periodInterestDay': 'فائدة يومية',
    'user.investments.modal.periodInterestYear': 'المعادل الشهري',
    'user.investments.modal.monthlyInterest': 'الفائدة الشهرية',
    'user.investments.modal.totalInterest': 'إجمالي الفائدة',
    'user.investments.modal.totalWithdrawal': 'إجمالي السحب',
    'user.investments.modal.periodHoursOnly': '{{hours}} ساعة',
    'user.investments.modal.periodDaysOnly': '{{days}} أيام',
    'user.investments.modal.periodDaysHours': '{{days}} أيام {{hours}} ساعة',
    'user.investments.modal.hintPlanChange':
      'يُسمح بتغيير الخطة خلال {{period}} من الاختيار',
    'user.investments.modal.hintCancellation':
      'يمكن إلغاء الاستثمار خلال أول {{period}}',
    'user.investments.modal.hintWeekdayOnly':
      'تُضاف الفائدة إلى الرصيد المتاح أيام الأسبوع فقط',
    'user.investments.modal.submit': 'تأكيد الاستثمار',
    'user.investments.modal.submitting': 'جاري المعالجة…',
    'user.investments.modal.toastInvalidAmount': 'يرجى إدخال مبلغ صالح.',
    'user.investments.modal.toastSubscribeFail': 'فشل الاشتراك',
    'user.investments.modal.toastSubscribeOk': 'تم الاشتراك في الاستثمار بنجاح',
    'user.investments.earlyWithdraw.title': 'تحذير السحب المبكر',
    'user.investments.earlyWithdraw.investmentAmount': 'مبلغ الاستثمار:',
    'user.investments.earlyWithdraw.platformFee': 'رسوم المنصة ({{pct}}%):',
    'user.investments.earlyWithdraw.interestForfeited': 'الفائدة المفقودة:',
    'user.investments.earlyWithdraw.interestIncluded': 'مضمن',
    'user.investments.earlyWithdraw.youReceive': 'ستستلم:',
    'user.investments.earlyWithdraw.processing': 'جاري المعالجة…',
    'user.investments.earlyWithdraw.confirm': 'تأكيد',
    'user.investments.active.planFallback': 'خطة',
    'user.investments.active.badgeActive': 'نشط',
    'user.investments.active.labelAmount': 'المبلغ',
    'user.investments.active.labelCurrent': 'القيمة الحالية',
    'user.investments.active.labelRate': 'المعدل',
    'user.investments.active.ratePerMonth': '{{pct}}% / شهر',
    'user.investments.active.labelPl': 'ر/خ',
    'user.investments.active.labelInterestEst': 'الفائدة (تقدير)',
    'user.investments.active.labelStart': 'تاريخ البدء',
    'user.investments.active.labelMaturity': 'تاريخ الاستحقاق',
    'user.investments.active.nextWithdrawal': 'السحب التالي خلال',
    'user.investments.active.progress': 'التقدم',
    'user.investments.active.progressPct': '{{pct}}% مكتمل',
    'user.investments.active.earlyWithdrawCta': 'سحب مبكر',
    'user.stopLoss.slots.assignCta': 'تعيين لخطة استثمار',
    'user.withdraw.form.amount': 'المبلغ (USD)',
    'user.withdraw.form.available': 'الرصيد المتاح:',
    'user.withdraw.form.placeholderAmount': '0.00',
    'user.withdraw.form.feeTitle': 'رسوم السحب: {{pct}}%',
    'user.withdraw.form.feeBody':
      'يتم خصم {{pct}}% من مبلغ السحب. إلغاء الخطة المبكر له رسوم منفصلة.',
    'user.withdraw.form.noFeeTitle': 'بدون رسوم منصة',
    'user.withdraw.form.noFeeBody':
      'سحوبات المحفظة بدون رسوم منصة. إلغاء الخطة المبكر له رسوم منفصلة.',
    'user.withdraw.form.walletPlaceholder': 'أدخل عنوان محفظة USDT',
    'user.withdraw.form.loadingBalance': 'جاري التحميل…',
  },

  ja: {
    'user.investments.loadingActive': '運用中の投資を読み込み中…',
    'user.investments.loadFailed': '運用中の投資を読み込めませんでした',
    'user.investments.emptyTitle': '運用中の投資はありません',
    'user.investments.emptyDesc': 'プランを選んで投資を始めましょう',
    'user.investments.browsePlans': 'プランを見る',
    'user.investments.tab.browse': 'プランを見る',
    'user.investments.tab.active': '運用中の投資',
    'user.investments.tab.history': '履歴',
    'user.investments.plan.compound': '複利',
    'user.investments.plan.simple': '単利',
    'user.investments.card.minPrincipal': '最低元本',
    'user.investments.card.maxPrincipal': '最高元本',
    'user.investments.card.interestRate': '金利',
    'user.investments.card.dailyProfit': '日次利益',
    'user.investments.card.earningDays': '営業日',
    'user.investments.card.earningDaysValue': '営業日 {{count}} 日',
    'user.investments.card.duration': '期間',
    'user.investments.card.durationMonths': '{{n}}か月',
    'user.investments.card.interestType': '利払いタイプ',
    'user.investments.card.expectedProfit': '予想利益',
    'user.investments.card.totalReturn': '総リターン',
    'user.investments.card.comingSoonLine': '近日公開',
    'user.investments.card.launchingSoon': '近日開始 — お楽しみに',
    'user.investments.card.comingSoonBadge': '近日公開',
    'user.investments.card.notAvailable': '利用不可',
    'user.investments.card.investNow': '今すぐ投資',
    'user.investments.card.investLimit': '投資上限',
    'user.investments.card.investLimitLine': '{{days}}日間で{{count}}回',
    'user.investments.card.investLimitReached':
      '現在の期間におけるこのプランの投資上限に達しました。',
    'user.investments.card.limitReached': '上限に達しました',
    'user.investments.history.title': '投資履歴',
    'user.investments.history.loading': '履歴を読み込み中…',
    'user.investments.history.empty': '投資履歴はまだありません。',
    'user.investments.history.col.plan': 'プラン',
    'user.investments.history.col.amount': '投資金額',
    'user.investments.history.col.rate': '金利',
    'user.investments.history.col.duration': '期間',
    'user.investments.history.col.returns': '獲得リターン',
    'user.investments.history.col.endDate': '終了日',
    'user.investments.history.col.status': 'ステータス',
    'user.investments.history.months': '{{n}}か月',
    'user.investments.history.rateMo': '{{pct}}%/月',
    'user.investments.history.rateTerm': '{{pct}}%',
    'user.investments.history.rateDay': '{{pct}}%/day',
    'user.investments.history.st.active': '運用中',
    'user.investments.history.st.cancelled': 'キャンセル',
    'user.investments.history.st.completed': '完了',
    'user.investments.history.st.pending': '保留',
    'user.investments.modal.amountLabel': '金額（USD）',
    'user.investments.modal.placeholderAmount': '金額を入力',
    'user.investments.modal.minMax': '最小: {{min}} · 最大: {{max}}',
    'user.investments.modal.available': '利用可能残高: {{amount}}',
    'user.investments.modal.availableLoading': '利用可能残高: 読み込み中…',
    'user.investments.modal.errMin': '最小投資額は {{min}} です',
    'user.investments.modal.errMax': '最大投資額は {{max}} です',
    'user.investments.modal.errInsufficient':
      '残高不足です。{{amount}}が必要ですが、利用可能は{{available}}です。',
    'user.investments.modal.toastInsufficient': '残高不足です。先に入金してください。',
    'user.investments.modal.projectedTitle': '想定リターン',
    'user.investments.modal.periodInterestTerm': 'プラン利息',
    'user.investments.modal.periodInterestDay': '日次利息',
    'user.investments.modal.periodInterestYear': '月換算',
    'user.investments.modal.monthlyInterest': '月次利息',
    'user.investments.modal.totalInterest': '利息合計',
    'user.investments.modal.totalWithdrawal': '引出合計',
    'user.investments.modal.periodHoursOnly': '{{hours}}時間',
    'user.investments.modal.periodDaysOnly': '{{days}}日',
    'user.investments.modal.periodDaysHours': '{{days}}日{{hours}}時間',
    'user.investments.modal.hintPlanChange': '選択後{{period}}以内にプラン変更可',
    'user.investments.modal.hintCancellation':
      '最初の{{period}}以内は投資をキャンセルできます',
    'user.investments.modal.hintWeekdayOnly':
      '利息は平日のみ利用可能残高に付与されます',
    'user.investments.modal.submit': '投資を確定',
    'user.investments.modal.submitting': '処理中…',
    'user.investments.modal.toastInvalidAmount': '有効な金額を入力してください。',
    'user.investments.modal.toastSubscribeFail': '申し込みに失敗しました',
    'user.investments.modal.toastSubscribeOk': '投資の申し込みが完了しました',
    'user.investments.earlyWithdraw.title': '早期引出の注意',
    'user.investments.earlyWithdraw.investmentAmount': '投資金額:',
    'user.investments.earlyWithdraw.platformFee': 'プラットフォーム手数料（{{pct}}%）:',
    'user.investments.earlyWithdraw.interestForfeited': '放棄する利息:',
    'user.investments.earlyWithdraw.interestIncluded': '含む',
    'user.investments.earlyWithdraw.youReceive': '受取予定額:',
    'user.investments.earlyWithdraw.processing': '処理中…',
    'user.investments.earlyWithdraw.confirm': '確認',
    'user.investments.active.planFallback': 'プラン',
    'user.investments.active.badgeActive': 'アクティブ',
    'user.investments.active.labelAmount': '金額',
    'user.investments.active.labelCurrent': '現在価値',
    'user.investments.active.labelRate': '金利',
    'user.investments.active.ratePerMonth': '月 {{pct}}%',
    'user.investments.active.labelPl': '損益',
    'user.investments.active.labelInterestEst': '利息（推定）',
    'user.investments.active.labelStart': '開始日',
    'user.investments.active.labelMaturity': '満期日',
    'user.investments.active.nextWithdrawal': '次回引出まで',
    'user.investments.active.progress': '進捗',
    'user.investments.active.progressPct': '{{pct}}% 完了',
    'user.investments.active.earlyWithdrawCta': '早期引出',
    'user.stopLoss.slots.assignCta': '投資プランに割り当て',
    'user.withdraw.form.amount': '金額（USD）',
    'user.withdraw.form.available': '利用可能残高:',
    'user.withdraw.form.placeholderAmount': '0.00',
    'user.withdraw.form.feeTitle': '出金手数料: {{pct}}%',
    'user.withdraw.form.feeBody':
      '出金額の{{pct}}%が手数料として差し引かれます。プランの早期解約は別料金です。',
    'user.withdraw.form.noFeeTitle': 'プラットフォーム手数料なし',
    'user.withdraw.form.noFeeBody':
      'ウォレット出金にプラットフォーム手数料はかかりません。プランの早期解約は別料金です。',
    'user.withdraw.form.walletPlaceholder': 'USDTウォレットアドレスを入力',
    'user.withdraw.form.loadingBalance': '読み込み中…',
  },

  ko: {
    'user.investments.loadingActive': '진행 중인 투자를 불러오는 중…',
    'user.investments.loadFailed': '진행 중인 투자를 불러올 수 없습니다',
    'user.investments.emptyTitle': '진행 중인 투자가 없습니다',
    'user.investments.emptyDesc': '플랜을 둘러보고 투자를 시작하세요',
    'user.investments.browsePlans': '플랜 둘러보기',
    'user.investments.tab.browse': '플랜 둘러보기',
    'user.investments.tab.active': '진행 중인 투자',
    'user.investments.tab.history': '내역',
    'user.investments.plan.compound': '복리',
    'user.investments.plan.simple': '단리',
    'user.investments.card.minPrincipal': '최소 원금',
    'user.investments.card.maxPrincipal': '최대 원금',
    'user.investments.card.interestRate': '이자율',
    'user.investments.card.dailyProfit': '일일 수익',
    'user.investments.card.earningDays': '영업일',
    'user.investments.card.earningDaysValue': '영업일 {{count}}일',
    'user.investments.card.duration': '기간',
    'user.investments.card.durationMonths': '{{n}}개월',
    'user.investments.card.interestType': '이자 유형',
    'user.investments.card.expectedProfit': '예상 수익',
    'user.investments.card.totalReturn': '총 수익',
    'user.investments.card.comingSoonLine': '곧 공개',
    'user.investments.card.launchingSoon': '곧 시작됩니다 — 기대해 주세요',
    'user.investments.card.comingSoonBadge': '곧 공개',
    'user.investments.card.notAvailable': '이용 불가',
    'user.investments.card.investNow': '지금 투자',
    'user.investments.card.investLimit': '투자 한도',
    'user.investments.card.investLimitLine': '{{days}}일 동안 {{count}}회',
    'user.investments.card.investLimitReached':
      '현재 기간에 이 플랜의 투자 한도에 도달했습니다.',
    'user.investments.card.limitReached': '한도 도달',
    'user.investments.history.title': '투자 내역',
    'user.investments.history.loading': '내역을 불러오는 중…',
    'user.investments.history.empty': '아직 투자 내역이 없습니다.',
    'user.investments.history.col.plan': '플랜',
    'user.investments.history.col.amount': '투자 금액',
    'user.investments.history.col.rate': '이자율',
    'user.investments.history.col.duration': '기간',
    'user.investments.history.col.returns': '누적 수익',
    'user.investments.history.col.endDate': '종료일',
    'user.investments.history.col.status': '상태',
    'user.investments.history.months': '{{n}}개월',
    'user.investments.history.rateMo': '{{pct}}%/월',
    'user.investments.history.rateTerm': '{{pct}}%',
    'user.investments.history.rateDay': '{{pct}}%/day',
    'user.investments.history.st.active': '진행 중',
    'user.investments.history.st.cancelled': '취소됨',
    'user.investments.history.st.completed': '완료',
    'user.investments.history.st.pending': '대기',
    'user.investments.modal.amountLabel': '금액 (USD)',
    'user.investments.modal.placeholderAmount': '금액 입력',
    'user.investments.modal.minMax': '최소: {{min}} · 최대: {{max}}',
    'user.investments.modal.available': '사용 가능 잔액: {{amount}}',
    'user.investments.modal.availableLoading': '사용 가능 잔액: 불러오는 중…',
    'user.investments.modal.errMin': '최소 투자 금액은 {{min}}입니다',
    'user.investments.modal.errMax': '최대 투자 금액은 {{max}}입니다',
    'user.investments.modal.errInsufficient':
      '잔액이 부족합니다. {{amount}}가 필요하지만 사용 가능한 금액은 {{available}}입니다.',
    'user.investments.modal.toastInsufficient': '잔액이 부족합니다. 먼저 입금해 주세요.',
    'user.investments.modal.projectedTitle': '예상 수익',
    'user.investments.modal.periodInterestTerm': '플랜 이자',
    'user.investments.modal.periodInterestDay': '일일 이자',
    'user.investments.modal.periodInterestYear': '월 환산',
    'user.investments.modal.monthlyInterest': '월 이자',
    'user.investments.modal.totalInterest': '총 이자',
    'user.investments.modal.totalWithdrawal': '총 인출',
    'user.investments.modal.periodHoursOnly': '{{hours}}시간',
    'user.investments.modal.periodDaysOnly': '{{days}}일',
    'user.investments.modal.periodDaysHours': '{{days}}일 {{hours}}시간',
    'user.investments.modal.hintPlanChange': '선택 후 {{period}} 이내 플랜 변경 가능',
    'user.investments.modal.hintCancellation': '첫 {{period}} 이내 투자 취소 가능',
    'user.investments.modal.hintWeekdayOnly':
      '이자는 평일에만 사용 가능 잔액으로 적립됩니다',
    'user.investments.modal.submit': '투자 확정',
    'user.investments.modal.submitting': '처리 중…',
    'user.investments.modal.toastInvalidAmount': '유효한 금액을 입력하세요.',
    'user.investments.modal.toastSubscribeFail': '가입에 실패했습니다',
    'user.investments.modal.toastSubscribeOk': '투자 가입이 완료되었습니다',
    'user.investments.earlyWithdraw.title': '조기 인출 안내',
    'user.investments.earlyWithdraw.investmentAmount': '투자 금액:',
    'user.investments.earlyWithdraw.platformFee': '플랫폼 수수료 ({{pct}}%):',
    'user.investments.earlyWithdraw.interestForfeited': '포기하는 이자:',
    'user.investments.earlyWithdraw.interestIncluded': '포함',
    'user.investments.earlyWithdraw.youReceive': '받게 될 금액:',
    'user.investments.earlyWithdraw.processing': '처리 중…',
    'user.investments.earlyWithdraw.confirm': '확인',
    'user.investments.active.planFallback': '플랜',
    'user.investments.active.badgeActive': '활성',
    'user.investments.active.labelAmount': '금액',
    'user.investments.active.labelCurrent': '현재 가치',
    'user.investments.active.labelRate': '금리',
    'user.investments.active.ratePerMonth': '월 {{pct}}%',
    'user.investments.active.labelPl': '손익',
    'user.investments.active.labelInterestEst': '이자 (추정)',
    'user.investments.active.labelStart': '시작일',
    'user.investments.active.labelMaturity': '만기일',
    'user.investments.active.nextWithdrawal': '다음 인출까지',
    'user.investments.active.progress': '진행률',
    'user.investments.active.progressPct': '{{pct}}% 완료',
    'user.investments.active.earlyWithdrawCta': '조기 인출',
    'user.stopLoss.slots.assignCta': '투자 플랜에 할당',
    'user.withdraw.form.amount': '금액 (USD)',
    'user.withdraw.form.available': '사용 가능 잔액:',
    'user.withdraw.form.placeholderAmount': '0.00',
    'user.withdraw.form.feeTitle': '출금 수수료: {{pct}}%',
    'user.withdraw.form.feeBody':
      '출금 금액의 {{pct}}%가 수수료로 차감됩니다. 플랜 조기 해지는 별도 수수료가 적용됩니다.',
    'user.withdraw.form.noFeeTitle': '플랫폼 수수료 없음',
    'user.withdraw.form.noFeeBody':
      '지갑 출금에는 플랫폼 수수료가 없습니다. 플랜 조기 해지는 별도 수수료가 적용됩니다.',
    'user.withdraw.form.walletPlaceholder': 'USDT 지갑 주소 입력',
    'user.withdraw.form.loadingBalance': '로딩 중…',
  },

  'zh-CN': {
    'user.investments.loadingActive': '正在加载进行中的投资…',
    'user.investments.loadFailed': '无法加载进行中的投资',
    'user.investments.emptyTitle': '暂无进行中的投资',
    'user.investments.emptyDesc': '浏览计划并开始投资',
    'user.investments.browsePlans': '浏览计划',
    'user.investments.tab.browse': '浏览计划',
    'user.investments.tab.active': '进行中的投资',
    'user.investments.tab.history': '历史记录',
    'user.investments.plan.compound': '复利',
    'user.investments.plan.simple': '单利',
    'user.investments.card.minPrincipal': '最低本金',
    'user.investments.card.maxPrincipal': '最高本金',
    'user.investments.card.interestRate': '利率',
    'user.investments.card.dailyProfit': '日收益',
    'user.investments.card.earningDays': '计息工作日',
    'user.investments.card.earningDaysValue': '{{count}} 个工作日',
    'user.investments.card.duration': '期限',
    'user.investments.card.durationMonths': '{{n}} 个月',
    'user.investments.card.interestType': '计息方式',
    'user.investments.card.expectedProfit': '预期收益',
    'user.investments.card.totalReturn': '总回报',
    'user.investments.card.comingSoonLine': '即将推出',
    'user.investments.card.launchingSoon': '即将上线 — 敬请期待',
    'user.investments.card.comingSoonBadge': '即将推出',
    'user.investments.card.notAvailable': '不可用',
    'user.investments.card.investNow': '立即投资',
    'user.investments.card.investLimit': '投资限额',
    'user.investments.card.investLimitLine': '{{days}} 天内 {{count}} 次',
    'user.investments.card.investLimitReached': '您已达到该计划在当前周期内的投资限额。',
    'user.investments.card.limitReached': '已达限额',
    'user.investments.history.title': '投资历史',
    'user.investments.history.loading': '正在加载历史…',
    'user.investments.history.empty': '尚无投资历史。',
    'user.investments.history.col.plan': '计划',
    'user.investments.history.col.amount': '投资金额',
    'user.investments.history.col.rate': '利率',
    'user.investments.history.col.duration': '期限',
    'user.investments.history.col.returns': '已获收益',
    'user.investments.history.col.endDate': '结束日期',
    'user.investments.history.col.status': '状态',
    'user.investments.history.months': '{{n}} 个月',
    'user.investments.history.rateMo': '{{pct}}%/月',
    'user.investments.history.rateTerm': '{{pct}}%',
    'user.investments.history.rateDay': '{{pct}}%/day',
    'user.investments.history.st.active': '进行中',
    'user.investments.history.st.cancelled': '已取消',
    'user.investments.history.st.completed': '已完成',
    'user.investments.history.st.pending': '待处理',
    'user.investments.modal.amountLabel': '金额（USD）',
    'user.investments.modal.placeholderAmount': '输入金额',
    'user.investments.modal.minMax': '最低：{{min}} · 最高：{{max}}',
    'user.investments.modal.available': '可用余额：{{amount}}',
    'user.investments.modal.availableLoading': '可用余额：加载中…',
    'user.investments.modal.errMin': '最低投资金额为 {{min}}',
    'user.investments.modal.errMax': '最高投资金额为 {{max}}',
    'user.investments.modal.errInsufficient':
      '余额不足。需要 {{amount}}，可用 {{available}}。',
    'user.investments.modal.toastInsufficient': '余额不足，请先充值。',
    'user.investments.modal.projectedTitle': '预计回报',
    'user.investments.modal.periodInterestTerm': '计划利息',
    'user.investments.modal.periodInterestDay': '日利息',
    'user.investments.modal.periodInterestYear': '月均等价',
    'user.investments.modal.monthlyInterest': '月利息',
    'user.investments.modal.totalInterest': '利息合计',
    'user.investments.modal.totalWithdrawal': '提款合计',
    'user.investments.modal.periodHoursOnly': '{{hours}} 小时',
    'user.investments.modal.periodDaysOnly': '{{days}} 天',
    'user.investments.modal.periodDaysHours': '{{days}} 天 {{hours}} 小时',
    'user.investments.modal.hintPlanChange': '选择后 {{period}} 内可更改计划',
    'user.investments.modal.hintCancellation': '前 {{period}} 内可取消投资',
    'user.investments.modal.hintWeekdayOnly': '利息仅在工作日计入可用余额',
    'user.investments.modal.submit': '确认投资',
    'user.investments.modal.submitting': '处理中…',
    'user.investments.modal.toastInvalidAmount': '请输入有效金额。',
    'user.investments.modal.toastSubscribeFail': '认购失败',
    'user.investments.modal.toastSubscribeOk': '投资认购成功',
    'user.investments.earlyWithdraw.title': '提前提款提示',
    'user.investments.earlyWithdraw.investmentAmount': '投资金额：',
    'user.investments.earlyWithdraw.platformFee': '平台费用（{{pct}}%）：',
    'user.investments.earlyWithdraw.interestForfeited': '放弃的利息：',
    'user.investments.earlyWithdraw.interestIncluded': '已含',
    'user.investments.earlyWithdraw.youReceive': '您将收到：',
    'user.investments.earlyWithdraw.processing': '处理中…',
    'user.investments.earlyWithdraw.confirm': '确认',
    'user.investments.active.planFallback': '计划',
    'user.investments.active.badgeActive': '进行中',
    'user.investments.active.labelAmount': '金额',
    'user.investments.active.labelCurrent': '当前价值',
    'user.investments.active.labelRate': '利率',
    'user.investments.active.ratePerMonth': '每月 {{pct}}%',
    'user.investments.active.labelPl': '盈亏',
    'user.investments.active.labelInterestEst': '利息（估算）',
    'user.investments.active.labelStart': '开始日期',
    'user.investments.active.labelMaturity': '到期日期',
    'user.investments.active.nextWithdrawal': '下次提款在',
    'user.investments.active.progress': '进度',
    'user.investments.active.progressPct': '已完成 {{pct}}%',
    'user.investments.active.earlyWithdrawCta': '提前提款',
    'user.stopLoss.slots.assignCta': '分配到投资计划',
    'user.withdraw.form.amount': '金额（USD）',
    'user.withdraw.form.available': '可用余额：',
    'user.withdraw.form.placeholderAmount': '0.00',
    'user.withdraw.form.feeTitle': '提现手续费：{{pct}}%',
    'user.withdraw.form.feeBody':
      '从提现金额中扣除 {{pct}}% 平台手续费。提前取消计划另有单独费用。',
    'user.withdraw.form.noFeeTitle': '无平台费用',
    'user.withdraw.form.noFeeBody':
      '钱包提现无平台手续费。提前取消计划另有单独费用。',
    'user.withdraw.form.walletPlaceholder': '请输入 USDT 钱包地址',
    'user.withdraw.form.loadingBalance': '加载中…',
  },

  pt: {
    'user.investments.loadingActive': 'A carregar investimentos ativos…',
    'user.investments.loadFailed': 'Não foi possível carregar investimentos ativos',
    'user.investments.emptyTitle': 'Sem investimentos ativos',
    'user.investments.emptyDesc': 'Explore os planos e invista para começar',
    'user.investments.browsePlans': 'Explorar planos',
    'user.investments.tab.browse': 'Explorar planos',
    'user.investments.tab.active': 'Investimentos ativos',
    'user.investments.tab.history': 'Histórico',
    'user.investments.plan.compound': 'Juros compostos',
    'user.investments.plan.simple': 'Juros simples',
    'user.investments.card.minPrincipal': 'Principal mínimo',
    'user.investments.card.maxPrincipal': 'Principal máximo',
    'user.investments.card.interestRate': 'Taxa de juro',
    'user.investments.card.dailyProfit': 'Lucro diário',
    'user.investments.card.earningDays': 'Dias úteis',
    'user.investments.card.earningDaysValue': '{{count}} dias úteis',
    'user.investments.card.duration': 'Duração',
    'user.investments.card.durationMonths': '{{n}} meses',
    'user.investments.card.interestType': 'Tipo de juros',
    'user.investments.card.expectedProfit': 'Lucro esperado',
    'user.investments.card.totalReturn': 'Retorno total',
    'user.investments.card.comingSoonLine': 'Em breve',
    'user.investments.card.launchingSoon': 'Lançamento em breve — fique atento',
    'user.investments.card.comingSoonBadge': 'Em breve',
    'user.investments.card.notAvailable': 'Indisponível',
    'user.investments.card.investNow': 'Investir agora',
    'user.investments.card.investLimit': 'Limite de investimento',
    'user.investments.card.investLimitLine': '{{count}}× em {{days}} dias',
    'user.investments.card.investLimitReached':
      'Você atingiu o limite de investimento deste plano no período atual.',
    'user.investments.card.limitReached': 'Limite atingido',
    'user.investments.history.title': 'Histórico de investimentos',
    'user.investments.history.loading': 'A carregar histórico…',
    'user.investments.history.empty': 'Ainda não há histórico de investimentos.',
    'user.investments.history.col.plan': 'Plano',
    'user.investments.history.col.amount': 'Montante investido',
    'user.investments.history.col.rate': 'Taxa de juro',
    'user.investments.history.col.duration': 'Duração',
    'user.investments.history.col.returns': 'Retornos obtidos',
    'user.investments.history.col.endDate': 'Data de fim',
    'user.investments.history.col.status': 'Estado',
    'user.investments.history.months': '{{n}} meses',
    'user.investments.history.rateMo': '{{pct}}%/mês',
    'user.investments.history.rateTerm': '{{pct}}%',
    'user.investments.history.rateDay': '{{pct}}%/day',
    'user.investments.history.st.active': 'Ativo',
    'user.investments.history.st.cancelled': 'Cancelado',
    'user.investments.history.st.completed': 'Concluído',
    'user.investments.history.st.pending': 'Pendente',
    'user.investments.modal.amountLabel': 'Montante (USD)',
    'user.investments.modal.placeholderAmount': 'Introduza o montante',
    'user.investments.modal.minMax': 'Mín.: {{min}} · Máx.: {{max}}',
    'user.investments.modal.available': 'Saldo disponível: {{amount}}',
    'user.investments.modal.availableLoading': 'Saldo disponível: a carregar…',
    'user.investments.modal.errMin': 'O investimento mínimo é {{min}}',
    'user.investments.modal.errMax': 'O investimento máximo é {{max}}',
    'user.investments.modal.errInsufficient':
      'Saldo insuficiente. Precisa de {{amount}}, disponível: {{available}}.',
    'user.investments.modal.toastInsufficient': 'Saldo insuficiente. Deposite primeiro.',
    'user.investments.modal.projectedTitle': 'Retornos projetados',
    'user.investments.modal.periodInterestTerm': 'Juros do plano',
    'user.investments.modal.periodInterestDay': 'Juros diários',
    'user.investments.modal.periodInterestYear': 'Equivalente mensal',
    'user.investments.modal.monthlyInterest': 'Juros mensais',
    'user.investments.modal.totalInterest': 'Juros totais',
    'user.investments.modal.totalWithdrawal': 'Levantamento total',
    'user.investments.modal.periodHoursOnly': '{{hours}} horas',
    'user.investments.modal.periodDaysOnly': '{{days}} dias',
    'user.investments.modal.periodDaysHours': '{{days}} dias {{hours}} horas',
    'user.investments.modal.hintPlanChange':
      'Pode alterar o plano nas {{period}} após a seleção',
    'user.investments.modal.hintCancellation':
      'Pode cancelar o investimento nos primeiros {{period}}',
    'user.investments.modal.hintWeekdayOnly':
      'Os juros são creditados no saldo disponível apenas em dias úteis',
    'user.investments.modal.submit': 'Confirmar investimento',
    'user.investments.modal.submitting': 'A processar…',
    'user.investments.modal.toastInvalidAmount': 'Introduza um montante válido.',
    'user.investments.modal.toastSubscribeFail': 'Falha na subscrição',
    'user.investments.modal.toastSubscribeOk': 'Subscrição de investimento concluída',
    'user.investments.earlyWithdraw.title': 'Aviso de levantamento antecipado',
    'user.investments.earlyWithdraw.investmentAmount': 'Montante investido:',
    'user.investments.earlyWithdraw.platformFee': 'Taxa da plataforma ({{pct}}%):',
    'user.investments.earlyWithdraw.interestForfeited': 'Juros perdidos:',
    'user.investments.earlyWithdraw.interestIncluded': 'Incluído',
    'user.investments.earlyWithdraw.youReceive': 'Receberá:',
    'user.investments.earlyWithdraw.processing': 'A processar…',
    'user.investments.earlyWithdraw.confirm': 'Confirmar',
    'user.investments.active.planFallback': 'Plano',
    'user.investments.active.badgeActive': 'Ativo',
    'user.investments.active.labelAmount': 'Montante',
    'user.investments.active.labelCurrent': 'Valor atual',
    'user.investments.active.labelRate': 'Taxa',
    'user.investments.active.ratePerMonth': '{{pct}}% / mês',
    'user.investments.active.labelPl': 'P&L',
    'user.investments.active.labelInterestEst': 'Juros (est.)',
    'user.investments.active.labelStart': 'Data de início',
    'user.investments.active.labelMaturity': 'Data de vencimento',
    'user.investments.active.nextWithdrawal': 'Próximo levantamento em',
    'user.investments.active.progress': 'Progresso',
    'user.investments.active.progressPct': '{{pct}}% concluído',
    'user.investments.active.earlyWithdrawCta': 'Levantamento antecipado',
    'user.stopLoss.slots.assignCta': 'Atribuir ao plano de investimento',
    'user.withdraw.form.amount': 'Montante (USD)',
    'user.withdraw.form.available': 'Saldo disponível:',
    'user.withdraw.form.placeholderAmount': '0,00',
    'user.withdraw.form.feeTitle': 'Taxa de levantamento: {{pct}}%',
    'user.withdraw.form.feeBody':
      'É deduzido {{pct}}% do valor do levantamento. O cancelamento antecipado do plano tem taxa separada.',
    'user.withdraw.form.noFeeTitle': 'Sem taxa da plataforma',
    'user.withdraw.form.noFeeBody':
      'Levantamentos para carteira sem taxa de plataforma. O cancelamento antecipado do plano tem taxa separada.',
    'user.withdraw.form.walletPlaceholder': 'Introduza o endereço da carteira USDT',
    'user.withdraw.form.loadingBalance': 'A carregar…',
  },

  it: {
    'user.investments.loadingActive': 'Caricamento investimenti attivi…',
    'user.investments.loadFailed': 'Impossibile caricare gli investimenti attivi',
    'user.investments.emptyTitle': 'Nessun investimento attivo',
    'user.investments.emptyDesc': 'Sfoglia i piani e investi per iniziare',
    'user.investments.browsePlans': 'Sfoglia piani',
    'user.investments.tab.browse': 'Sfoglia piani',
    'user.investments.tab.active': 'Investimenti attivi',
    'user.investments.tab.history': 'Cronologia',
    'user.investments.plan.compound': 'Interesse composto',
    'user.investments.plan.simple': 'Interesse semplice',
    'user.investments.card.minPrincipal': 'Capitale minimo',
    'user.investments.card.maxPrincipal': 'Capitale massimo',
    'user.investments.card.interestRate': 'Tasso di interesse',
    'user.investments.card.dailyProfit': 'Profitto giornaliero',
    'user.investments.card.earningDays': 'Giorni lavorativi',
    'user.investments.card.earningDaysValue': '{{count}} giorni lavorativi',
    'user.investments.card.duration': 'Durata',
    'user.investments.card.durationMonths': '{{n}} mesi',
    'user.investments.card.interestType': 'Tipo di interesse',
    'user.investments.card.expectedProfit': 'Profitto atteso',
    'user.investments.card.totalReturn': 'Rendimento totale',
    'user.investments.card.comingSoonLine': 'Prossimamente',
    'user.investments.card.launchingSoon': 'In arrivo — resta sintonizzato',
    'user.investments.card.comingSoonBadge': 'Prossimamente',
    'user.investments.card.notAvailable': 'Non disponibile',
    'user.investments.card.investNow': 'Investi ora',
    'user.investments.card.investLimit': 'Limite investimento',
    'user.investments.card.investLimitLine': '{{count}}× in {{days}} giorni',
    'user.investments.card.investLimitReached':
      'Hai raggiunto il limite di investimento per questo piano nel periodo corrente.',
    'user.investments.card.limitReached': 'Limite raggiunto',
    'user.investments.history.title': 'Cronologia investimenti',
    'user.investments.history.loading': 'Caricamento cronologia…',
    'user.investments.history.empty': 'Non c’è ancora cronologia investimenti.',
    'user.investments.history.col.plan': 'Piano',
    'user.investments.history.col.amount': 'Importo investito',
    'user.investments.history.col.rate': 'Tasso di interesse',
    'user.investments.history.col.duration': 'Durata',
    'user.investments.history.col.returns': 'Rendimenti maturati',
    'user.investments.history.col.endDate': 'Data di fine',
    'user.investments.history.col.status': 'Stato',
    'user.investments.history.months': '{{n}} mesi',
    'user.investments.history.rateMo': '{{pct}}%/mese',
    'user.investments.history.rateTerm': '{{pct}}%',
    'user.investments.history.rateDay': '{{pct}}%/day',
    'user.investments.history.st.active': 'Attivo',
    'user.investments.history.st.cancelled': 'Annullato',
    'user.investments.history.st.completed': 'Completato',
    'user.investments.history.st.pending': 'In sospeso',
    'user.investments.modal.amountLabel': 'Importo (USD)',
    'user.investments.modal.placeholderAmount': 'Inserisci l’importo',
    'user.investments.modal.minMax': 'Min: {{min}} · Max: {{max}}',
    'user.investments.modal.available': 'Saldo disponibile: {{amount}}',
    'user.investments.modal.availableLoading': 'Saldo disponibile: caricamento…',
    'user.investments.modal.errMin': 'L’investimento minimo è {{min}}',
    'user.investments.modal.errMax': 'L’investimento massimo è {{max}}',
    'user.investments.modal.errInsufficient':
      'Saldo insufficiente. Servono {{amount}}, disponibili {{available}}.',
    'user.investments.modal.toastInsufficient': 'Saldo insufficiente. Effettua prima un deposito.',
    'user.investments.modal.projectedTitle': 'Rendimenti previsti',
    'user.investments.modal.periodInterestTerm': 'Interesse del piano',
    'user.investments.modal.periodInterestDay': 'Interesse giornaliero',
    'user.investments.modal.periodInterestYear': 'Equivalente mensile',
    'user.investments.modal.monthlyInterest': 'Interessi mensili',
    'user.investments.modal.totalInterest': 'Interessi totali',
    'user.investments.modal.totalWithdrawal': 'Prelievo totale',
    'user.investments.modal.periodHoursOnly': '{{hours}} ore',
    'user.investments.modal.periodDaysOnly': '{{days}} giorni',
    'user.investments.modal.periodDaysHours': '{{days}} giorni {{hours}} ore',
    'user.investments.modal.hintPlanChange':
      'Puoi cambiare piano entro {{period}} dalla scelta',
    'user.investments.modal.hintCancellation':
      'Puoi annullare l’investimento nei primi {{period}}',
    'user.investments.modal.hintWeekdayOnly':
      'Gli interessi vengono accreditati sul saldo disponibile solo nei giorni feriali',
    'user.investments.modal.submit': 'Conferma investimento',
    'user.investments.modal.submitting': 'Elaborazione…',
    'user.investments.modal.toastInvalidAmount': 'Inserisci un importo valido.',
    'user.investments.modal.toastSubscribeFail': 'Sottoscrizione non riuscita',
    'user.investments.modal.toastSubscribeOk': 'Sottoscrizione investimento completata',
    'user.investments.earlyWithdraw.title': 'Avviso prelievo anticipato',
    'user.investments.earlyWithdraw.investmentAmount': 'Importo investito:',
    'user.investments.earlyWithdraw.platformFee': 'Commissione piattaforma ({{pct}}%):',
    'user.investments.earlyWithdraw.interestForfeited': 'Interessi persi:',
    'user.investments.earlyWithdraw.interestIncluded': 'Incluso',
    'user.investments.earlyWithdraw.youReceive': 'Riceverai:',
    'user.investments.earlyWithdraw.processing': 'Elaborazione…',
    'user.investments.earlyWithdraw.confirm': 'Conferma',
    'user.investments.active.planFallback': 'Piano',
    'user.investments.active.badgeActive': 'Attivo',
    'user.investments.active.labelAmount': 'Importo',
    'user.investments.active.labelCurrent': 'Valore attuale',
    'user.investments.active.labelRate': 'Tasso',
    'user.investments.active.ratePerMonth': '{{pct}}% / mese',
    'user.investments.active.labelPl': 'P&L',
    'user.investments.active.labelInterestEst': 'Interessi (stim.)',
    'user.investments.active.labelStart': 'Data inizio',
    'user.investments.active.labelMaturity': 'Data scadenza',
    'user.investments.active.nextWithdrawal': 'Prossimo prelievo tra',
    'user.investments.active.progress': 'Avanzamento',
    'user.investments.active.progressPct': '{{pct}}% completato',
    'user.investments.active.earlyWithdrawCta': 'Prelievo anticipato',
    'user.stopLoss.slots.assignCta': 'Assegna al piano di investimento',
    'user.withdraw.form.amount': 'Importo (USD)',
    'user.withdraw.form.available': 'Saldo disponibile:',
    'user.withdraw.form.placeholderAmount': '0,00',
    'user.withdraw.form.feeTitle': 'Commissione prelievo: {{pct}}%',
    'user.withdraw.form.feeBody':
      'Viene detratto il {{pct}}% dell\'importo del prelievo. La cancellazione anticipata del piano ha una commissione separata.',
    'user.withdraw.form.noFeeTitle': 'Nessuna commissione piattaforma',
    'user.withdraw.form.noFeeBody':
      'I prelievi wallet non hanno commissione piattaforma. La cancellazione anticipata del piano ha una commissione separata.',
    'user.withdraw.form.walletPlaceholder': 'Inserisci l’indirizzo del wallet USDT',
    'user.withdraw.form.loadingBalance': 'Caricamento…',
  },

  ru: {
    'user.investments.loadingActive': 'Загрузка активных инвестиций…',
    'user.investments.loadFailed': 'Не удалось загрузить активные инвестиции',
    'user.investments.emptyTitle': 'Нет активных инвестиций',
    'user.investments.emptyDesc': 'Просмотрите планы и начните инвестировать',
    'user.investments.browsePlans': 'Смотреть планы',
    'user.investments.tab.browse': 'Смотреть планы',
    'user.investments.tab.active': 'Активные инвестиции',
    'user.investments.tab.history': 'История',
    'user.investments.plan.compound': 'Сложный процент',
    'user.investments.plan.simple': 'Простой процент',
    'user.investments.card.minPrincipal': 'Мин. капитал',
    'user.investments.card.maxPrincipal': 'Макс. капитал',
    'user.investments.card.interestRate': 'Процентная ставка',
    'user.investments.card.dailyProfit': 'Дневная прибыль',
    'user.investments.card.earningDays': 'Рабочие дни',
    'user.investments.card.earningDaysValue': '{{count}} раб. дн.',
    'user.investments.card.duration': 'Срок',
    'user.investments.card.durationMonths': '{{n}} мес.',
    'user.investments.card.interestType': 'Тип начисления',
    'user.investments.card.expectedProfit': 'Ожидаемая прибыль',
    'user.investments.card.totalReturn': 'Общая доходность',
    'user.investments.card.comingSoonLine': 'Скоро',
    'user.investments.card.launchingSoon': 'Скоро запуск — следите за новостями',
    'user.investments.card.comingSoonBadge': 'Скоро',
    'user.investments.card.notAvailable': 'Недоступно',
    'user.investments.card.investNow': 'Инвестировать',
    'user.investments.card.investLimit': 'Лимит инвестиций',
    'user.investments.card.investLimitLine': '{{count}}× за {{days}} дн.',
    'user.investments.card.investLimitReached':
      'Вы достигли лимита инвестиций по этому плану в текущем периоде.',
    'user.investments.card.limitReached': 'Лимит достигнут',
    'user.investments.history.title': 'История инвестиций',
    'user.investments.history.loading': 'Загрузка истории…',
    'user.investments.history.empty': 'Истории инвестиций пока нет.',
    'user.investments.history.col.plan': 'План',
    'user.investments.history.col.amount': 'Сумма инвестиции',
    'user.investments.history.col.rate': 'Процентная ставка',
    'user.investments.history.col.duration': 'Срок',
    'user.investments.history.col.returns': 'Заработано',
    'user.investments.history.col.endDate': 'Дата окончания',
    'user.investments.history.col.status': 'Статус',
    'user.investments.history.months': '{{n}} мес.',
    'user.investments.history.rateMo': '{{pct}}%/мес.',
    'user.investments.history.rateTerm': '{{pct}}%',
    'user.investments.history.rateDay': '{{pct}}%/day',
    'user.investments.history.st.active': 'Активно',
    'user.investments.history.st.cancelled': 'Отменено',
    'user.investments.history.st.completed': 'Завершено',
    'user.investments.history.st.pending': 'В ожидании',
    'user.investments.modal.amountLabel': 'Сумма (USD)',
    'user.investments.modal.placeholderAmount': 'Введите сумму',
    'user.investments.modal.minMax': 'Мин.: {{min}} · Макс.: {{max}}',
    'user.investments.modal.available': 'Доступный баланс: {{amount}}',
    'user.investments.modal.availableLoading': 'Доступный баланс: загрузка…',
    'user.investments.modal.errMin': 'Минимальная сумма инвестиции — {{min}}',
    'user.investments.modal.errMax': 'Максимальная сумма инвестиции — {{max}}',
    'user.investments.modal.errInsufficient':
      'Недостаточно средств. Нужно {{amount}}, доступно {{available}}.',
    'user.investments.modal.toastInsufficient': 'Недостаточно средств. Сначала пополните счёт.',
    'user.investments.modal.projectedTitle': 'Прогнозируемая доходность',
    'user.investments.modal.periodInterestTerm': 'Процент по плану',
    'user.investments.modal.periodInterestDay': 'Дневной процент',
    'user.investments.modal.periodInterestYear': 'Месячный эквивалент',
    'user.investments.modal.monthlyInterest': 'Ежемесячные проценты',
    'user.investments.modal.totalInterest': 'Проценты всего',
    'user.investments.modal.totalWithdrawal': 'Итого к выводу',
    'user.investments.modal.periodHoursOnly': '{{hours}} ч',
    'user.investments.modal.periodDaysOnly': '{{days}} дн.',
    'user.investments.modal.periodDaysHours': '{{days}} дн. {{hours}} ч',
    'user.investments.modal.hintPlanChange':
      'Можно сменить план в течение {{period}} после выбора',
    'user.investments.modal.hintCancellation':
      'Можно отменить инвестицию в первые {{period}}',
    'user.investments.modal.hintWeekdayOnly':
      'Проценты зачисляются на доступный баланс только в будние дни',
    'user.investments.modal.submit': 'Подтвердить инвестицию',
    'user.investments.modal.submitting': 'Обработка…',
    'user.investments.modal.toastInvalidAmount': 'Введите корректную сумму.',
    'user.investments.modal.toastSubscribeFail': 'Не удалось оформить подписку',
    'user.investments.modal.toastSubscribeOk': 'Инвестиция успешно оформлена',
    'user.investments.earlyWithdraw.title': 'Предупреждение о досрочном выводе',
    'user.investments.earlyWithdraw.investmentAmount': 'Сумма инвестиции:',
    'user.investments.earlyWithdraw.platformFee': 'Комиссия платформы ({{pct}}%):',
    'user.investments.earlyWithdraw.interestForfeited': 'Упущенные проценты:',
    'user.investments.earlyWithdraw.interestIncluded': 'Включено',
    'user.investments.earlyWithdraw.youReceive': 'Вы получите:',
    'user.investments.earlyWithdraw.processing': 'Обработка…',
    'user.investments.earlyWithdraw.confirm': 'Подтвердить',
    'user.investments.active.planFallback': 'План',
    'user.investments.active.badgeActive': 'Активно',
    'user.investments.active.labelAmount': 'Сумма',
    'user.investments.active.labelCurrent': 'Текущая стоимость',
    'user.investments.active.labelRate': 'Ставка',
    'user.investments.active.ratePerMonth': '{{pct}}% / мес.',
    'user.investments.active.labelPl': 'П/У',
    'user.investments.active.labelInterestEst': 'Проценты (оценка)',
    'user.investments.active.labelStart': 'Дата начала',
    'user.investments.active.labelMaturity': 'Дата погашения',
    'user.investments.active.nextWithdrawal': 'Следующий вывод через',
    'user.investments.active.progress': 'Прогресс',
    'user.investments.active.progressPct': '{{pct}}% завершено',
    'user.investments.active.earlyWithdrawCta': 'Досрочный вывод',
    'user.stopLoss.slots.assignCta': 'Назначить инвестиционному плану',
    'user.withdraw.form.amount': 'Сумма (USD)',
    'user.withdraw.form.available': 'Доступный баланс:',
    'user.withdraw.form.placeholderAmount': '0,00',
    'user.withdraw.form.feeTitle': 'Комиссия за вывод: {{pct}}%',
    'user.withdraw.form.feeBody':
      'С суммы вывода удерживается {{pct}}%. Досрочная отмена плана — отдельная комиссия.',
    'user.withdraw.form.noFeeTitle': 'Без комиссии платформы',
    'user.withdraw.form.noFeeBody':
      'Вывод на кошелёк без комиссии платформы. Досрочная отмена плана — отдельная комиссия.',
    'user.withdraw.form.walletPlaceholder': 'Введите адрес кошелька USDT',
    'user.withdraw.form.loadingBalance': 'Загрузка…',
  },

  bn: {
    'user.investments.loadingActive': 'সক্রিয় বিনিয়োগ লোড হচ্ছে…',
    'user.investments.loadFailed': 'সক্রিয় বিনিয়োগ লোড করা যায়নি',
    'user.investments.emptyTitle': 'কোনো সক্রিয় বিনিয়োগ নেই',
    'user.investments.emptyDesc': 'প্ল্যান ব্রাউজ করে বিনিয়োগ শুরু করুন',
    'user.investments.browsePlans': 'প্ল্যান দেখুন',
    'user.investments.tab.browse': 'প্ল্যান দেখুন',
    'user.investments.tab.active': 'সক্রিয় বিনিয়োগ',
    'user.investments.tab.history': 'ইতিহাস',
    'user.investments.plan.compound': 'চক্রবৃদ্ধি সুদ',
    'user.investments.plan.simple': 'সরল সুদ',
    'user.investments.card.minPrincipal': 'ন্যূনতম মূলধন',
    'user.investments.card.maxPrincipal': 'সর্বোচ্চ মূলধন',
    'user.investments.card.interestRate': 'সুদের হার',
    'user.investments.card.dailyProfit': 'দৈনিক লাভ',
    'user.investments.card.earningDays': 'কর্মদিবস',
    'user.investments.card.earningDaysValue': '{{count}} কর্মদিবস',
    'user.investments.card.duration': 'মেয়াদ',
    'user.investments.card.durationMonths': '{{n}} মাস',
    'user.investments.card.interestType': 'সুদের ধরন',
    'user.investments.card.expectedProfit': 'প্রত্যাশিত মুনাফা',
    'user.investments.card.totalReturn': 'মোট রিটার্ন',
    'user.investments.card.comingSoonLine': 'শীঘ্রই আসছে',
    'user.investments.card.launchingSoon': 'শীঘ্রই চালু — অপেক্ষায় থাকুন',
    'user.investments.card.comingSoonBadge': 'শীঘ্রই',
    'user.investments.card.notAvailable': 'উপলব্ধ নয়',
    'user.investments.card.investNow': 'এখনই বিনিয়োগ করুন',
    'user.investments.card.investLimit': 'বিনিয়োগ সীমা',
    'user.investments.card.investLimitLine': '{{days}} দিনে {{count}}×',
    'user.investments.card.investLimitReached':
      'বর্তমান সময়ে এই প্ল্যানের বিনিয়োগ সীমায় পৌঁছেছেন।',
    'user.investments.card.limitReached': 'সীমায় পৌঁছেছে',
    'user.investments.history.title': 'বিনিয়োগের ইতিহাস',
    'user.investments.history.loading': 'ইতিহাস লোড হচ্ছে…',
    'user.investments.history.empty': 'এখনো কোনো বিনিয়োগের ইতিহাস নেই।',
    'user.investments.history.col.plan': 'প্ল্যান',
    'user.investments.history.col.amount': 'বিনিয়োগকৃত অর্থ',
    'user.investments.history.col.rate': 'সুদের হার',
    'user.investments.history.col.duration': 'মেয়াদ',
    'user.investments.history.col.returns': 'অর্জিত রিটার্ন',
    'user.investments.history.col.endDate': 'শেষ তারিখ',
    'user.investments.history.col.status': 'স্ট্যাটাস',
    'user.investments.history.months': '{{n}} মাস',
    'user.investments.history.rateMo': '{{pct}}%/মাস',
    'user.investments.history.rateTerm': '{{pct}}%',
    'user.investments.history.rateDay': '{{pct}}%/day',
    'user.investments.history.st.active': 'সক্রিয়',
    'user.investments.history.st.cancelled': 'বাতিল',
    'user.investments.history.st.completed': 'সম্পন্ন',
    'user.investments.history.st.pending': 'অপেক্ষমাণ',
    'user.investments.modal.amountLabel': 'পরিমাণ (USD)',
    'user.investments.modal.placeholderAmount': 'পরিমাণ লিখুন',
    'user.investments.modal.minMax': 'সর্বনিম্ন: {{min}} · সর্বোচ্চ: {{max}}',
    'user.investments.modal.available': 'উপলব্ধ ব্যালেন্স: {{amount}}',
    'user.investments.modal.availableLoading': 'উপলব্ধ ব্যালেন্স: লোড হচ্ছে…',
    'user.investments.modal.errMin': 'সর্বনিম্ন বিনিয়োগ {{min}}',
    'user.investments.modal.errMax': 'সর্বোচ্চ বিনিয়োগ {{max}}',
    'user.investments.modal.errInsufficient':
      'অপর্যাপ্ত ব্যালেন্স। আপনার {{amount}} প্রয়োজন, কিন্তু আছে মাত্র {{available}}।',
    'user.investments.modal.toastInsufficient': 'অপর্যাপ্ত ব্যালেন্স। প্রথমে জমা দিন।',
    'user.investments.modal.projectedTitle': 'প্রক্ষেপিত রিটার্ন',
    'user.investments.modal.periodInterestTerm': 'প্ল্যান সুদ',
    'user.investments.modal.periodInterestDay': 'দৈনিক সুদ',
    'user.investments.modal.periodInterestYear': 'মাসিক সমতুল্য',
    'user.investments.modal.monthlyInterest': 'মাসিক সুদ',
    'user.investments.modal.totalInterest': 'মোট সুদ',
    'user.investments.modal.totalWithdrawal': 'মোট উত্তোলন',
    'user.investments.modal.periodHoursOnly': '{{hours}} ঘণ্টা',
    'user.investments.modal.periodDaysOnly': '{{days}} দিন',
    'user.investments.modal.periodDaysHours': '{{days}} দিন {{hours}} ঘণ্টা',
    'user.investments.modal.hintPlanChange':
      'নির্বাচনের {{period}} এর মধ্যে প্ল্যান পরিবর্তন করা যাবে',
    'user.investments.modal.hintCancellation':
      'প্রথম {{period}} এ বিনিয়োগ বাতিল করা যাবে',
    'user.investments.modal.hintWeekdayOnly':
      'সুদ শুধুই সপ্তাহের দিনগুলোতে উপলব্ধ ব্যালেন্সে যোগ হয়',
    'user.investments.modal.submit': 'বিনিয়োগ নিশ্চিত করুন',
    'user.investments.modal.submitting': 'প্রক্রিয়াকরণ…',
    'user.investments.modal.toastInvalidAmount': 'বৈধ পরিমাণ লিখুন।',
    'user.investments.modal.toastSubscribeFail': 'সাবস্ক্রিপশন ব্যর্থ',
    'user.investments.modal.toastSubscribeOk': 'বিনিয়োগ সাবস্ক্রিপশন সফল',
    'user.investments.earlyWithdraw.title': 'আগাম উত্তোলন সতর্কতা',
    'user.investments.earlyWithdraw.investmentAmount': 'বিনিয়োগের পরিমাণ:',
    'user.investments.earlyWithdraw.platformFee': 'প্ল্যাটফর্ম ফি ({{pct}}%):',
    'user.investments.earlyWithdraw.interestForfeited': 'হারানো সুদ:',
    'user.investments.earlyWithdraw.interestIncluded': 'অন্তর্ভুক্ত',
    'user.investments.earlyWithdraw.youReceive': 'আপনি পাবেন:',
    'user.investments.earlyWithdraw.processing': 'প্রক্রিয়াকরণ…',
    'user.investments.earlyWithdraw.confirm': 'নিশ্চিত করুন',
    'user.investments.active.planFallback': 'প্ল্যান',
    'user.investments.active.badgeActive': 'সক্রিয়',
    'user.investments.active.labelAmount': 'পরিমাণ',
    'user.investments.active.labelCurrent': 'বর্তমান মূল্য',
    'user.investments.active.labelRate': 'হার',
    'user.investments.active.ratePerMonth': 'মাসে {{pct}}%',
    'user.investments.active.labelPl': 'লাভ/ক্ষতি',
    'user.investments.active.labelInterestEst': 'সুদ (আনুমানিক)',
    'user.investments.active.labelStart': 'শুরুর তারিখ',
    'user.investments.active.labelMaturity': 'মেয়াদ শেষের তারিখ',
    'user.investments.active.nextWithdrawal': 'পরবর্তী উত্তোলন',
    'user.investments.active.progress': 'অগ্রগতি',
    'user.investments.active.progressPct': '{{pct}}% সম্পন্ন',
    'user.investments.active.earlyWithdrawCta': 'আগাম উত্তোলন',
    'user.stopLoss.slots.assignCta': 'বিনিয়োগ প্ল্যানে বরাদ্দ করুন',
    'user.withdraw.form.amount': 'পরিমাণ (USD)',
    'user.withdraw.form.available': 'উপলব্ধ ব্যালেন্স:',
    'user.withdraw.form.placeholderAmount': '0.00',
    'user.withdraw.form.feeTitle': 'উত্তোলন ফি: {{pct}}%',
    'user.withdraw.form.feeBody':
      'উত্তোলনের {{pct}}% ফি কাটা হয়। আগাম প্ল্যান বাতিলের জন্য আলাদা ফি প্রযোজ্য।',
    'user.withdraw.form.noFeeTitle': 'কোনো প্ল্যাটফর্ম ফি নেই',
    'user.withdraw.form.noFeeBody':
      'ওয়ালেট উত্তোলনে প্ল্যাটফর্ম ফি নেই। আগাম প্ল্যান বাতিলের জন্য আলাদা ফি প্রযোজ্য।',
    'user.withdraw.form.walletPlaceholder': 'আপনার USDT ওয়ালেট ঠিকানা লিখুন',
    'user.withdraw.form.loadingBalance': 'লোড হচ্ছে…',
  },

  hi: {
    'user.investments.loadingActive': 'सक्रिय निवेश लोड हो रहे हैं…',
    'user.investments.loadFailed': 'सक्रिय निवेश लोड नहीं हो सके',
    'user.investments.emptyTitle': 'कोई सक्रिय निवेश नहीं',
    'user.investments.emptyDesc': 'योजनाएँ देखें और निवेश शुरू करें',
    'user.investments.browsePlans': 'योजनाएँ देखें',
    'user.investments.tab.browse': 'योजनाएँ देखें',
    'user.investments.tab.active': 'सक्रिय निवेश',
    'user.investments.tab.history': 'इतिहास',
    'user.investments.plan.compound': 'चक्रवृद्धि ब्याज',
    'user.investments.plan.simple': 'साधारण ब्याज',
    'user.investments.card.minPrincipal': 'न्यूनतम मूलधन',
    'user.investments.card.maxPrincipal': 'अधिकतम मूलधन',
    'user.investments.card.interestRate': 'ब्याज दर',
    'user.investments.card.dailyProfit': 'दैनिक लाभ',
    'user.investments.card.earningDays': 'कार्य दिवस',
    'user.investments.card.earningDaysValue': '{{count}} कार्य दिवस',
    'user.investments.card.duration': 'अवधि',
    'user.investments.card.durationMonths': '{{n}} महीने',
    'user.investments.card.interestType': 'ब्याज प्रकार',
    'user.investments.card.expectedProfit': 'अपेक्षित लाभ',
    'user.investments.card.totalReturn': 'कुल रिटर्न',
    'user.investments.card.comingSoonLine': 'जल्द आ रहा है',
    'user.investments.card.launchingSoon': 'जल्द शुरू — बने रहें',
    'user.investments.card.comingSoonBadge': 'जल्द',
    'user.investments.card.notAvailable': 'उपलब्ध नहीं',
    'user.investments.card.investNow': 'अभी निवेश करें',
    'user.investments.card.investLimit': 'निवेश सीमा',
    'user.investments.card.investLimitLine': '{{days}} दिन में {{count}}×',
    'user.investments.card.investLimitReached':
      'आपने इस योजना की वर्तमान अवधि की निवेश सीमा पूरी कर ली है।',
    'user.investments.card.limitReached': 'सीमा पूरी',
    'user.investments.history.title': 'निवेश इतिहास',
    'user.investments.history.loading': 'इतिहास लोड हो रहा है…',
    'user.investments.history.empty': 'अभी तक कोई निवेश इतिहास नहीं।',
    'user.investments.history.col.plan': 'योजना',
    'user.investments.history.col.amount': 'निवेशित राशि',
    'user.investments.history.col.rate': 'ब्याज दर',
    'user.investments.history.col.duration': 'अवधि',
    'user.investments.history.col.returns': 'अर्जित रिटर्न',
    'user.investments.history.col.endDate': 'समाप्ति तिथि',
    'user.investments.history.col.status': 'स्थिति',
    'user.investments.history.months': '{{n}} महीने',
    'user.investments.history.rateMo': '{{pct}}%/माह',
    'user.investments.history.rateTerm': '{{pct}}%',
    'user.investments.history.rateDay': '{{pct}}%/day',
    'user.investments.history.st.active': 'सक्रिय',
    'user.investments.history.st.cancelled': 'रद्द',
    'user.investments.history.st.completed': 'पूर्ण',
    'user.investments.history.st.pending': 'लंबित',
    'user.investments.modal.amountLabel': 'राशि (USD)',
    'user.investments.modal.placeholderAmount': 'राशि दर्ज करें',
    'user.investments.modal.minMax': 'न्यूनतम: {{min}} · अधिकतम: {{max}}',
    'user.investments.modal.available': 'उपलब्ध शेष: {{amount}}',
    'user.investments.modal.availableLoading': 'उपलब्ध शेष: लोड हो रहा है…',
    'user.investments.modal.errMin': 'न्यूनतम निवेश {{min}} है',
    'user.investments.modal.errMax': 'अधिकतम निवेश {{max}} है',
    'user.investments.modal.errInsufficient':
      'अपर्याप्त शेष। आपको {{amount}} चाहिए, उपलब्ध केवल {{available}}।',
    'user.investments.modal.toastInsufficient': 'अपर्याप्त शेष। कृपया पहले जमा करें।',
    'user.investments.modal.projectedTitle': 'अनुमानित रिटर्न',
    'user.investments.modal.periodInterestTerm': 'योजना ब्याज',
    'user.investments.modal.periodInterestDay': 'दैनिक ब्याज',
    'user.investments.modal.periodInterestYear': 'मासिक समतुल्य',
    'user.investments.modal.monthlyInterest': 'मासिक ब्याज',
    'user.investments.modal.totalInterest': 'कुल ब्याज',
    'user.investments.modal.totalWithdrawal': 'कुल निकासी',
    'user.investments.modal.periodHoursOnly': '{{hours}} घंटे',
    'user.investments.modal.periodDaysOnly': '{{days}} दिन',
    'user.investments.modal.periodDaysHours': '{{days}} दिन {{hours}} घंटे',
    'user.investments.modal.hintPlanChange':
      'चयन के {{period}} के भीतर योजना बदल सकते हैं',
    'user.investments.modal.hintCancellation':
      'पहले {{period}} में निवेश रद्द कर सकते हैं',
    'user.investments.modal.hintWeekdayOnly':
      'ब्याज केवल कार्यदिवसों पर उपलब्ध शेष में जमा होता है',
    'user.investments.modal.submit': 'निवेश पुष्टि करें',
    'user.investments.modal.submitting': 'प्रसंस्करण…',
    'user.investments.modal.toastInvalidAmount': 'कृपया वैध राशि दर्ज करें।',
    'user.investments.modal.toastSubscribeFail': 'सदस्यता विफल',
    'user.investments.modal.toastSubscribeOk': 'निवेश सदस्यता सफल',
    'user.investments.earlyWithdraw.title': 'समयपूर्व निकासी चेतावनी',
    'user.investments.earlyWithdraw.investmentAmount': 'निवेश राशि:',
    'user.investments.earlyWithdraw.platformFee': 'प्लेटफ़ॉर्म शुल्क ({{pct}}%):',
    'user.investments.earlyWithdraw.interestForfeited': 'त्यागा गया ब्याज:',
    'user.investments.earlyWithdraw.interestIncluded': 'शामिल',
    'user.investments.earlyWithdraw.youReceive': 'आपको मिलेगा:',
    'user.investments.earlyWithdraw.processing': 'प्रसंस्करण…',
    'user.investments.earlyWithdraw.confirm': 'पुष्टि करें',
    'user.investments.active.planFallback': 'योजना',
    'user.investments.active.badgeActive': 'सक्रिय',
    'user.investments.active.labelAmount': 'राशि',
    'user.investments.active.labelCurrent': 'वर्तमान मूल्य',
    'user.investments.active.labelRate': 'दर',
    'user.investments.active.ratePerMonth': 'प्रति माह {{pct}}%',
    'user.investments.active.labelPl': 'लाभ/हानि',
    'user.investments.active.labelInterestEst': 'ब्याज (अनुमानित)',
    'user.investments.active.labelStart': 'प्रारंभ तिथि',
    'user.investments.active.labelMaturity': 'परिपक्वता तिथि',
    'user.investments.active.nextWithdrawal': 'अगली निकासी',
    'user.investments.active.progress': 'प्रगति',
    'user.investments.active.progressPct': '{{pct}}% पूर्ण',
    'user.investments.active.earlyWithdrawCta': 'समयपूर्व निकासी',
    'user.stopLoss.slots.assignCta': 'निवेश योजना में असाइन करें',
    'user.withdraw.form.amount': 'राशि (USD)',
    'user.withdraw.form.available': 'उपलब्ध शेष:',
    'user.withdraw.form.placeholderAmount': '0.00',
    'user.withdraw.form.feeTitle': 'निकासी शुल्क: {{pct}}%',
    'user.withdraw.form.feeBody':
      'निकासी राशि का {{pct}}% शुल्क काटा जाता है। जल्दी प्लान रद्दीकरण पर अलग शुल्क लागू होता है।',
    'user.withdraw.form.noFeeTitle': 'कोई प्लेटफ़ॉर्म शुल्क नहीं',
    'user.withdraw.form.noFeeBody':
      'वॉलेट निकासी पर कोई प्लेटफ़ॉर्म शुल्क नहीं। जल्दी प्लान रद्दीकरण पर अलग शुल्क लागू होता है।',
    'user.withdraw.form.walletPlaceholder': 'अपना USDT वॉलेट पता दर्ज करें',
    'user.withdraw.form.loadingBalance': 'लोड हो रहा है…',
  },
};
